// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class PrescriptionProgramNdcModel {
    static getAttributeTypeMap() {
        return PrescriptionProgramNdcModel.attributeTypeMap;
    }
}
PrescriptionProgramNdcModel.discriminator = undefined;
PrescriptionProgramNdcModel.additionalProperties = false;
PrescriptionProgramNdcModel.attributeTypeMap = [
    {
        "name": "programPromotionXrefId",
        "baseName": "programPromotionXrefId",
        "type": "number"
    },
    {
        "name": "programNdcXrefId",
        "baseName": "programNdcXrefId",
        "type": "number"
    },
    {
        "name": "id",
        "baseName": "id",
        "type": "number"
    },
    {
        "name": "name",
        "baseName": "name",
        "type": "string"
    },
    {
        "name": "drugNumber",
        "baseName": "drugNumber",
        "type": "string"
    },
    {
        "name": "strengthDescription",
        "baseName": "strengthDescription",
        "type": "string"
    },
];
//# sourceMappingURL=prescriptionProgramNdcModel.js.map